(function() {
  var section = document.querySelector('.collection-products');
  if (!section) return;

  var toggleBtn = section.querySelector('[data-filter-toggle]');
  var closeBtn = section.querySelector('[data-filter-close]');
  var overlay = section.querySelector('[data-filter-overlay]');
  var panel = section.querySelector('[data-filter-panel]');
  var applyBtn = section.querySelector('[data-filter-apply]');
  var resetBtn = section.querySelector('[data-filter-reset]');
  var sheetCloseBtn = section.querySelector('[data-filter-sheet-close]');

  if (!toggleBtn || !panel) return;

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function openPanel() {
    var scrollbarWidth = getScrollbarWidth();
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
    panel.classList.add('is-open');
    overlay.classList.add('is-open');
    if (sheetCloseBtn) sheetCloseBtn.classList.add('is-open');
    document.body.classList.add('rr-filter-sheet-open');
  }

  function closePanel() {
    panel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    if (sheetCloseBtn) sheetCloseBtn.classList.remove('is-open');
    document.body.classList.remove('rr-filter-sheet-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  toggleBtn.addEventListener('click', openPanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlay) overlay.addEventListener('click', closePanel);
  if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closePanel);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      closePanel();
    }
  });

  // Collapsible section toggles
  section.querySelectorAll('[data-filter-section-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      btn.closest('[data-filter-section]').classList.toggle('is-open');
    });
  });

  // Apply filters
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var url = new URL(window.location.href);

      // Clear all existing filter, sort, and page params
      var keysToDelete = [];
      url.searchParams.forEach(function(val, key) {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
          keysToDelete.push(key);
        }
      });
      keysToDelete.forEach(function(key) {
        url.searchParams.delete(key);
      });

      // List/boolean filters (checkboxes with name starting with "filter.")
      panel.querySelectorAll('input[type="checkbox"]:checked').forEach(function(input) {
        if (input.name.startsWith('filter.')) {
          url.searchParams.append(input.name, input.value);
        }
      });

      // Price range inputs
      panel.querySelectorAll('[data-price-range-filter]').forEach(function(priceBlock) {
        var minInput = priceBlock.querySelector('[data-price-min]');
        var maxInput = priceBlock.querySelector('[data-price-max]');
        if (minInput && minInput.value !== '' && Number(minInput.value) > 0) {
          url.searchParams.set(minInput.name, minInput.value);
        }
        if (maxInput && maxInput.value !== '' && Number(maxInput.value) > 0) {
          url.searchParams.set(maxInput.name, maxInput.value);
        }
      });

      // Sort
      var sortInput = panel.querySelector('input[name="sort_by"]:checked');
      if (sortInput) {
        url.searchParams.set('sort_by', sortInput.value);
      }

      window.location.href = url.toString();
    });
  }

  // Reset filters
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      // Drop filters + sort, but keep the search query on /search
      var current = new URL(window.location.href);
      var url = new URL(window.location.pathname, window.location.origin);
      ['q', 'type', 'options[prefix]'].forEach(function(key) {
        var val = current.searchParams.get(key);
        if (val !== null) url.searchParams.set(key, val);
      });
      window.location.href = url.toString();
    });
  }

  /* =====================================================
     Infinite scroll for the products grid
     Uses Shopify Section Rendering API (?section_id=) to
     pull the next page's rendered section, then appends
     the new cards into the existing grid. Falls back to
     the visible pagination nav on error or no JS.
     ===================================================== */
  (function initInfiniteScroll() {
    var grid = section.querySelector('[data-products-grid]');
    if (!grid) return;

    var nextUrl = (grid.getAttribute('data-next-url') || '').trim();
    if (!nextUrl) return; // already on last page

    var sentinel = section.querySelector('[data-products-sentinel]');
    var loader   = section.querySelector('[data-products-loader]');
    var errorBox = section.querySelector('[data-products-error]');
    var retryBtn = section.querySelector('[data-products-retry]');
    var sectionId = grid.getAttribute('data-section-id') || '';
    if (!sentinel) return;

    // JS is available -> hide the legacy pagination nav
    section.classList.add('has-infinite-scroll');

    var loading = false;

    function buildSectionUrl(rawUrl) {
      // Append ?section_id= so Shopify returns only the section HTML
      if (!sectionId) return rawUrl;
      var sep = rawUrl.indexOf('?') > -1 ? '&' : '?';
      return rawUrl + sep + 'section_id=' + encodeURIComponent(sectionId);
    }

    function showError() {
      if (loader) loader.hidden = true;
      if (errorBox) errorBox.hidden = false;
    }

    function hideError() {
      if (errorBox) errorBox.hidden = true;
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      hideError();
      if (loader) loader.hidden = false;

      var url = buildSectionUrl(nextUrl);

      fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function(html) {
          // Parse the partial HTML returned by Section Rendering API
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-products-grid]');
          if (!newGrid) throw new Error('grid not found in response');

          // Move new cards into the live grid
          var newCards = Array.prototype.slice.call(newGrid.children);
          newCards.forEach(function(card) {
            // Skip the "No products match your filters." placeholder if present
            if (card.classList && card.classList.contains('collection-products__empty')) return;
            grid.appendChild(card);
          });

          // Read the next URL from the newly fetched grid
          nextUrl = (newGrid.getAttribute('data-next-url') || '').trim();

          if (!nextUrl) {
            // Last page reached — stop observing and remove sentinel
            if (observer && sentinel) observer.unobserve(sentinel);
            if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
          }

          // Re-fire any image lazy-load listeners the theme has
          document.dispatchEvent(new CustomEvent('rr:cards:appended'));
        })
        .catch(function(err) {
          showError();
        })
        .then(function() {
          loading = false;
          if (loader) loader.hidden = true;
        });
    }

    // Sentinel-based trigger (preferred)
    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(sentinel);
    } else {
      // Old-browser fallback: scroll listener
      var onScroll = function() {
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 400) loadNext();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (retryBtn) retryBtn.addEventListener('click', loadNext);
  })();
})();
